import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Search: 'Search',
  ClearFilter: 'Clear filter',
  Filter: 'Filter',
});

export default messages;
